const getDomElSiblings = (element) => {
  let siblings = [];
  let currentElement = element;
  while (currentElement && currentElement.nextSibling) {
    currentElement = currentElement.nextSibling;
    siblings.push(currentElement);
  }

  return siblings;
};

export default getDomElSiblings;
